export const logAliasMap = {
    s_email: 'EMAIL',
    s_unit: 'UNIT',
    i_employee_number: 'EMPLOYEE NUMBER',
    s_first_name: 'FIRST NAME',
    s_last_name: 'LAST NAME',
    d_hire: 'DATE OF HIRE',
    s_work_type: 'WORK TYPE',
    s_phone_num: 'PHONE NUMBER',
    s_job_title: 'JOB TITLE',
    s_department: 'DEPARTMENT',
    s_status: 'STATUS',
    i_access_level: 'ACCESS LEVEL',
    d_terminated: 'TERMINATED DATE',
    d_suspended_start: 'SUSPENDED DATE START',
    d_suspended_end: 'SUSPENDED DATE END',
    d_furlough_start: 'FURLOUGH DATE START',
    d_furlough_end: 'FURLOUGH DATE END',
    b_airline: 'AIRLINE'
}